import { SearchIcon } from "assets/icons/HeroIcons";
import { CrossIcon } from "assets/icons/HeroIcons/CrossIcon";
import useCustomBranding from "hooks/useCustomBranding";

interface SearchBarProps {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  handleSearch: (search: any) => void;
  handleClearSearch: () => void;
  error: string | undefined;
  touched: boolean | undefined;
  loading: boolean;
}

export const SearchBar = ({
  searchQuery,
  setSearchQuery,
  handleSearch,
  handleClearSearch,
  error,
  touched,
  loading,
}: SearchBarProps) => {
  const { primaryColor } = useCustomBranding();
  return (
    <div className="relative mb-9">
      <input
        type="text"
        name="message"
        placeholder="Type text to search..."
        className="w-full border border-lineDarkExtra bg-[#f3f5f7] focus-visible:outline-none rounded-full px-4 h-[52px] pr-24 pb-[3px]"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && searchQuery && !loading) {
            handleSearch(searchQuery);
          }
        }}
      />
      {touched && error && (
        <p className="absolute -bottom-5 left-0 flex-grow w-[1/2] text-xs text-left text-accent_1Dark">
          {error}
        </p>
      )}

      {searchQuery && (
        <button
          type="button"
          className="absolute right-14 top-1/2 -translate-y-1/2"
          onClick={handleClearSearch}
        >
          <CrossIcon fill={primaryColor} className="h-5 w-5 pt-1" />
        </button>
      )}

      <button
        type="button"
        className={`${(!searchQuery || loading) && "cursor-not-allowed opacity-50"} absolute right-1 top-1/2 -translate-y-1/2 bg-primary hover:bg-primaryDark h-[45px] w-[45px] flex items-center justify-center rounded-full`}
        onClick={() => handleSearch(searchQuery)}
        disabled={!searchQuery || loading}
      >
        <SearchIcon fill="#fff" className="h-5 w-5" />
      </button>
    </div>
  );
};
